export default "__VITE_ASSET__Bz9WePFn__"